import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";
import CaregiverSurveyTrophyHeader from "../CaregiverSurveyTrophyHeader/CaregiverSurveyTrophyHeader";

interface Props {
  onClickFinish: () => void;
}

const CaregiverSurveyFinish = (props: Props) => {
  return (
    <div className="CaregiverSurveyFinish">
      <CaregiverSurveyTrophyHeader />
      <div className="surveyContent">
        <p>{translate(STRINGS.THANK_YOU)}</p>
        <AppButton color="black" variant="outline" onClick={props.onClickFinish}>
          {translate(STRINGS.CLOSE_SURVEY)}
        </AppButton>
      </div>
    </div>
  );
};

export default React.memo(CaregiverSurveyFinish);
